import $ from 'jquery';

var init = function () {
    if (window.FB) {
        FB.init({
            appId      : '529896383846981',
            xfbml      : true,
            version    : 'v2.5'
        });
        $('.fb-share').removeClass('share-disabled');
        $('.fb-share').addClass('share-enabled');
    } else {
        window.fbAsyncInit = init;
    }
};

var share = function (e) {
    e.preventDefault();
    var url = $(this).data('url'),
        href = url ? url : window.location.href;
    FB.ui({
        method: 'share',
        href: href,
    }, function(response){});
};

$(function () {
    init();
    $(document).on('click', '.fb-share', share);
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/facebook.js
 **/